export function formatDate(timestamp: number) {
  const date = new Date(timestamp);
  const day = date.toLocaleDateString('default', { day: '2-digit' });
  const month = date.toLocaleDateString('default', { month: 'short' });
  const year = date.toLocaleDateString('default', { year: 'numeric' });
  const time = date.toLocaleTimeString().replace(/\u202f/g, ' '); // Replace narrow no-break space with regular space;

  return `${day} ${month} ${year} ${time}`;
}
